<template>
  <div class="locationManagement">
    <div class="title">
      <div>{{ $t('newApp.ADList.AddMana') }}</div>
    </div>
    <div class="container">
      <div class="common_btnBar">
        <el-button type="primary" @click="addLocationHandle">{{ $t('newApp.ADList.na') }}</el-button>
      </div>
      <commonTable ref="locationManagementTable" />
    </div>
    <addLocationDialog :add-location-show="addLocationShow" :row-data="rowData" @dialogCloseHandle="dialogCloseHandle"
      @submitSuccess="addLocationSuccess" />
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
import addLocationDialog from './addLocationDialog';
import { locationManagementApi } from '../../service';
export default {
  data() {
    return {
      tableData: [],
      rowData: {},
      addLocationShow: false
    };
  },
  props: {
    locationManagementVisible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    locationManagementVisible(val) {
      if (val) {
        this.getAddressList();
        this.loadTable();
      }
    }
  },
  components: {
    commonTable,
    addLocationDialog
  },
  methods: {
    addLocationSuccess() {
      this.addLocationShow = false;
      this.getAddressList();
    },
    editHandler(row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.addLocationShow = true;
    },
    addLocationHandle() {
      this.addLocationShow = true;
    },
    dialogCloseHandle() {
      this.addLocationShow = false;
      this.rowData = {};
    },
    setAddressCache(data) {
      let cacheList = [];
      for (let i = 0; i < 4; i++) {
        let key = 'province';
        let parentKey = '';
        let leafNode = false;
        switch (i) {
          case 1:
            key = 'city';
            parentKey = 'province';
            break;
          case 2:
            key = 'county';
            parentKey = 'city';
            if (!data.street && !data.streetCode) {
              leafNode = true;
            }
            break;
          case 3:
            key = 'street';
            parentKey = 'county';
            leafNode = true;
        }
        if (i === 3 && !data.street && !data.streetCode) {
          break;
        }
        cacheList[i] = {};
        cacheList[i].name = data[key];
        cacheList[i].code = data[key + 'Code'];
        cacheList[i].parentCode = data[parentKey + 'Code'];
        cacheList[i].leafNode = leafNode;
      }
      sessionStorage.setItem('selectedAddressList', JSON.stringify(cacheList));
    },
    deleteHandler(row) {
      this.$confirm(`${this.$t('newApp.ADList.Cdota')}?`, this.$t('newApp.ADList.DeleAdd'), {
        confirmButtonText: this.$t('btn.OK'),
        cancelButtonText: this.$t('btn.Cancel'),
        type: 'warning'
      }).then(() => {
        this.$store.commit('setSubPageLoading', true);
        locationManagementApi.deleteAddress(row.id).then(res => {
          if (res.status === '200') {
            this.$message.success(this.$t('general.DeleSucc'));
            this.getAddressList();
          }
          this.$store.commit('setSubPageLoading', false);
        });
      }).catch(() => { });
    },
    setDefaultHandler(row) {
      this.$confirm(`${this.$t('newApp.ADList.Dwtstaatda')}?`, this.$t('newApp.ADList.Sada'), {
        confirmButtonText: this.$t('btn.OK'),
        cancelButtonText: this.$t('btn.Cancel'),
        type: 'warning'
      }).then(() => {
        this.$store.commit('setSubPageLoading', true);
        locationManagementApi.setDefaultAddress(row.id).then(res => {
          if (res.status === '200') {
            this.$message.success(this.$t('general.SetupSucc'));
            this.getAddressList();
            this.setAddressCache(row);
          }
          this.$store.commit('setSubPageLoading', false);
        });
      }).catch(() => { });
    },
    getAddressList() {
      this.$refs.locationManagementTable.loading = true;
      locationManagementApi.getAddressList().then(res => {
        if (res.status === '200') {
          this.tableData = res.data.map(item => {
            if (item.countryType) {
              item.addressArea = item.country;
            } else {
              item.addressArea = `${item.province}/${item.city}/${item.county}${item.street ? '/' + item.street : ''}`;
            }
            return item;
          });
          this.loadTable();
        }
        this.$refs.locationManagementTable.loading = false;
      });
    },
    loadTable() {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.cp'))
          ._data('consignee')
          ._width('100')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.ADList.Aa'))
          ._data('addressArea')
          ._width('160')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.ADList.Da'))
          ._data('detailedAddress')
          ._width('160')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.ADList.Mp'))
          ._data('consigneePhone')
          ._width('160')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.Operation'))
          ._width('160')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  {
                    !row.isDefault ? (
                      <el-button type="text" onClick={() => { this.setDefaultHandler(row); }}>{this.$t('newApp.ADList.Sad')}</el-button>
                    ) : null
                  }
                  <el-button type="text" onClick={() => { this.editHandler(row); }}>{this.$t('btn.Edit')}</el-button>
                  {
                    this.tableData.length > 1 ? (
                      <el-button type="text" onClick={() => { this.deleteHandler(row); }}>{this.$t('btn.Delete')}</el-button>
                    ) : null
                  }
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.locationManagementTable.setColumn(column, {
          page: false,
          maxHeight: 'none'
        });
        this.$refs.locationManagementTable.loadStaticTable(this.tableData);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/main";

.locationManagement {
  width: 100%;
  height: 100%;

  >.title {
    width: 100%;
    background: #FFFFFF;
    line-height: 58px;

    >div {
      width: 1200px;
      margin: 0 auto;
      font-size: 18px;
      color: #424C57;
    }
  }

  >.container {
    width: 1200px;
    margin: 20px auto;
    padding: 30px 20px 40px;
    background: #FFFFFF;
  }
}
</style>
